import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: {},
        showLogin: false,
        panelStatus: false,
        is4399: false,
        process: 1,
        missionCompleteStatus: true, // 任务是否全部完成
    },
  getters: {
      userInfo: state => {
          return state.userInfo;
      },
      missionCompleteStatus: state => {
          return state.missionCompleteStatus;
      },
      showLogin: state => {
          return state.showLogin;
      },
      process: state => {
          return state.process;
      },
      panelStatus: state => {
          return state.panelStatus;
      },
      is4399: state => {
          return state.is4399;
      },
  },
  mutations: {
      setShowLogin (state, showLogin) {
          state.showLogin = showLogin
      },
      setMissionCompleteStatus (state, status) {
          state.missionCompleteStatus = status
      },
      setUserInfo (state, userInfo) {
          state.userInfo = userInfo;
      },
      setProcess (state, process) {
          state.process = process;
      },
      setPanelStatus (state, panelStatus) {
          state.panelStatus = panelStatus;
      },
      setIs4399 (state, is4399) {
          state.is4399 = is4399;
      },
  },
  actions: {
  },
  modules: {
  }
})
